
































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/rules-engine';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { getHealthInsurance } from '@/services/prescription';
import { getAvailableTherapies } from '../../services/client-unit';
import ListMessages from '../UI/list-messages.vue';

@Component({
  components: { PermissionAuth, ListMessages },
})
export default class ClientUnitTherapies extends BaseComponent {
  @Prop()
  public unit: any;

  @Prop({default: false})
  public simplified: boolean;

  @Prop({
    default: false,
  })
  public isEdit: boolean;

  private therapiesOptions: any[] = [];
  private obs: string = null;
  private loading: boolean = false;
  private error: boolean = false;

  @Watch('unit.id')
  private onUnitChange() {
    if (!this.unit || !this.unit.id) {
      return;
    }
    this.error = false;
    this.loading = true;
    this.addSubsc(
      getAvailableTherapies(this.unit.id, this.simplified).subscribe(
        (result) => {
          this.therapiesOptions = result.lista;
          this.obs = result.observacao;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
  }
}
